import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { HomeMemberResult } from 'src/app/core/model/api-response/cooking-story-model';
import { User } from 'src/app/core/model/user-model';
import { CookingStoryGroceryService } from 'src/app/data/repository/cooking-story/cooking-story-grocery.service';
import { CookingStoryGroceryApiService } from 'src/app/data/repository/cooking-story/cooking-story-kitchen-api.service';
import { CookingStoryMembersService } from 'src/app/data/repository/cooking-story/cooking-story-members.service';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';
import { TutorialDataService } from 'src/app/data/repository/tutorial-repository/tutorial-data.service';
import { UserDataService } from 'src/app/data/repository/user-repository/user-data.service';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { CookingStoryMembersEditComponent } from './cooking-story-members-edit/cooking-story-members-edit.component';
import { CookingStoryMembersInviteComponent } from './cooking-story-members-invite/cooking-story-members-invite.component';
import { CookingStoryMembersShareComponent } from './cooking-story-members-share/cooking-story-members-share.component';

@Component({
  selector: 'app-cooking-story-members',
  templateUrl: './cooking-story-members.component.html',
  styleUrls: ['./cooking-story-members.component.scss'],
})
export class CookingStoryMembersComponent implements OnInit, OnDestroy {
  constructor(
    private recipeService: RecipeService,
    private groceryApiService: CookingStoryGroceryApiService,
    private route: ActivatedRoute,
    private matBottomSheet: MatBottomSheet,
    private userDataService: UserDataService,
    private CookingStoryMembersService: CookingStoryMembersService,
    private snackBar: SnackBarService,
    private CookingStoryGroceryService: CookingStoryGroceryService,
    private TutorialDataService: TutorialDataService
  ) {}
  membersLength: number = 0;
  invite: string;
  home: HomeMemberResult;
  homeId: string;
  isReady: boolean = false;
  isOwner: boolean = false;
  userId: string;
  subscription1: Subscription;
  subscription2: Subscription;
  showTutorial: boolean = false;
  ngOnInit(): void {
    this.getHome();
    this.subscription1 = this.CookingStoryMembersService.updateUser.subscribe(
      (user) => {
        this.getHome();
      }
    );
    this.subscription2 =
      this.CookingStoryGroceryService.closeTutorial.subscribe((hide) => {
        if (hide) {
          this.showTutorial = false;
          this.TutorialDataService.getTutorial().then((res) => {
            res.members = true;
            this.TutorialDataService.saveTutorial(res);
          });
        }
      });
    this.checkTutorial();
  }
  checkTutorial() {
    this.TutorialDataService.getTutorial().then((res) => {
      if (!res.members) {
        this.showTutorial = true;
      }
    });
  }
  getHome() {
    this.groceryApiService.getHomeMembers().then((homeDate) => {
      if (homeDate.isSuccess()) {
        this.home = homeDate.getData().getHomeMembers().home;
        this.homeId = this.home._id;
        this.userDataService.getUser().then((user) => {
          this.userId = user._id;
          if (this.home.owner._id == this.userId) {
            this.isOwner = true;
          }
        });
        this.route.queryParamMap.subscribe((data) => {
          this.invite = data.get('invite');
          if (this.invite) {
            this.detectToInvite();
          }
        });
        this.membersLength = this.home.members.length + 1;
        this.isReady = true;
      }
    });
  }
  garr(l: number) {
    return new Array(l);
  }
  goBack() {
    this.recipeService.goTocookingbook();
  }
  getProfile(user: User) {
    if (user.avatar != '' && user.avatar) return user.avatar;
    if (user.sex == 'male') return 'assets/cookingbook/men.svg';
    return 'assets/cookingbook/women.svg';
  }
  openShare() {
    const bottomSheetRef = this.matBottomSheet.open(
      CookingStoryMembersShareComponent,
      {
        panelClass: 'custom-bottomsheet-container',
        data: {
          id: this.homeId,
        },
      }
    );
  }
  isMe(id: string) {
    if (id == this.userId) return true;

    return false;
  }
  detectToInvite() {
    this.groceryApiService
      .getHomeMembers(this.invite)
      .then((homeDate) => {
        const data = homeDate.getData().getHomeMembers().home;
        if (homeDate.isSuccess() && data.owner && data.members) {
          const bottomSheetRef = this.matBottomSheet.open(
            CookingStoryMembersInviteComponent,
            {
              panelClass: 'custom-bottomsheet-container',
              data: data,
            }
          );
        } else {
          this.snackBar.showSnackBar('ادرس خانه اشتباه است');
          this.recipeService.goToHomeMembers();
        }
      })
      .catch((d) => {
        this.snackBar.showSnackBar('ادرس خانه اشتباه است');

        this.recipeService.goToHomeMembers();
      });
  }
  editUser(user: User, leave = false, type = 'kick') {
    if (this.isOwner || leave) {
      this.matBottomSheet.open(CookingStoryMembersEditComponent, {
        panelClass: 'custom-bottomsheet-container',
        data: { user, type },
      });
    }
  }
  leave() {
    const user = this.home.members.find((d) => d.user._id == this.userId).user;
    if (user) {
      this.editUser(user, true, 'leave');
    }
  }
  ngOnDestroy() {
    this.subscription1.unsubscribe();
  }
}
